import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';

class SizeRomp extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			romp: this.props.romp
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
		this.skipBtn = this.skipBtn.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState({romp: nextProps.romp})
	}

	componentDidMount() {
	  window.scrollTo(0, 0);
	}

	render() {

		let avarage = Math.round((this.props.length / 10 ) * 0.823);

		return(
				<form className="sizes" onSubmit={this.handleSubmit}>

					<div className="row justify-content-center">
						<div className="col-12 text-center title">

							  <h2>{this.props.t('Wat is jouw romphoogte?')}</h2>

						</div>
						<div className="col-sm-6 center-text">
							<div className="row">
								<div className="col-sm-6">
									<div className="shadow-column">
										<img className="sizes-img img-responsive" src="/img/silhouette/body_4.png" alt="opmeten romp"/>
									</div>
								</div>
								<div className="col-sm-6">
									<div className="shadow-column">
										<img className="sizes-img img-responsive" src="/img/romphoogte_2.png" alt="opmeten romp"/>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="row justify-content-center">
								<div className="col-12 title">
									<div className="shadow-column">
										<ul>
											<li>{this.props.t('Blijf met je rug recht tegen de muur staan')}</li>
											<li>{this.props.t('Meet de afstand van de')} <strong>{this.props.t('grond tot de onderkant van het V-vormige plekje')}</strong> {this.props.t('bovenaan je borstbeen')}</li>
											<li>{this.props.t('SizeRomp-Bekijk de foto goed zodat')}</li>
										</ul>
									</div>
								</div>
								<div className="col-12">
									<div className="shadow-column  text-center">

										<h3>{this.props.t('Romphoogte')}</h3>
										<div className="input-group mb-3">
										<input id="romp" className="form-control" name="romp" type="number" min={avarage - 10} max={avarage + 10} step="0.1" defaultValue={this.state.romp ? this.state.romp / 10 : ''} onChange={this.handleChange} />
										<div className="input-group-append">
												<span className="input-group-text" id="basic-addon2">{this.props.t('CM')}</span>
											</div>
										</div>
										<i>{this.props.t('Gemiddeld voor jouw lengte is')} {avarage}{this.props.t('cm')}.</i>
									</div>
								</div>


							</div>
						</div>
					</div>
					<div className="row form-buttons">


						<div className="col-6 text-left">
							<button type="button" className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
						</div>
						<div className="col-6 text-right">
							<button type="button" id="skipbtn" className="btn btn-secondary" onClick={this.skipBtn}>{this.props.t('Sla over')}</button>
							<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
						</div>

					</div>
				</form>

		);

	}





	handleChange(event) {
		this.setState({romp: event.target.value * 10});
	}

	handleSubmit(event) {
		event.preventDefault();
		if(this.state.romp) {
			this.props.handleSubmit(this.state.romp);
		} else {
			alert('vul uw romphoogte in');
		}
	}
	goBack(event) {
		event.preventDefault();
		this.props.back();
	}
	skipBtn(e) {
		e.preventDefault();
		this.props.nextAdviceStep();
	}
}

export default withTranslation('sizesBody')(SizeRomp);
